// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { xBaseTheme } from "@trc/XDL/types";
import { css } from "styled-components";

const heroBigCss = css`
    &.hero-big {
        font-family: "Open Sans", sans-serif, open-sans;
        font-size: 65px;
        line-height: 80px;
        transform: uppercase;

        ${({ theme }: { theme: xBaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        && {
                            font-size: 45px;
                            line-height: 50px;
                        }
                    `,
                    css`
                        font-size: 60px;
                        line-height: 65px;
                    `,
                ],
                "max",
            )}
    }
`;

export default {
    fontFamilyImportUrl: "",
    body: {
        size: "14px",
        lineHeight: "16px",
        weight: 400,
        fontFamily: "'Open Sans',  sans-serif, open-sans",
    },
    p: {
        size: "14px",
        lineHeight: "16px",
        weight: 400,
        css: css`
            margin-bottom: 15px;
            &.hero-small {
                font-family: "Open Sans", sans-serif;
                font-size: 42px;
                line-height: 40px;
                transform: uppercase;
            }
        `,
    },
    h1: {
        size: "30px",
        lineHeight: "35px",
        fontFamily: "'Open Sans',  sans-serif",
        weight: "bold",
        transform: "uppercase",
        css: css`
            margin-bottom: 15px;
        `,
    },
    h2: {
        size: "24px",
        lineHeight: "28px",
        fontFamily: "'Open Sans',  sans-serif",
        weight: "bold",
        transform: "uppercase",
        css: css`
            margin-bottom: 15px;
            ${heroBigCss}
        `,
    },
    h3: {
        size: "20px",
        lineHeight: "24px",
        fontFamily: "'Open Sans',  sans-serif",
        weight: 400,
        transform: "uppercase",
        css: css`
            letter-spacing: 0.27px;
            margin-bottom: 15px;
        `,
    },
    h4: {
        size: "20px",
        lineHeight: "24px",
        weight: 400,
        transform: "uppercase",
        css: css`
            letter-spacing: 0.25px;
            margin-bottom: 15px;
        `,
    },
    h5: {
        size: "18px",
        lineHeight: "20px",
        weight: 900,
        transform: "uppercase",
        css: css`
            letter-spacing: 0.24px;
            margin-bottom: 15px;
        `,
    },
    h6: {
        size: "16px",
        lineHeight: "20px",
        weight: 700,
        fontFamily: "'Open Sans',  sans-serif",
        transform: "uppercase",
        css: css`
            letter-spacing: 0.21px;
            margin-bottom: 15px;
        `,
    },
    headerPrimary: {
        forwardAs: "p",
        size: "24px",
        fontFamily: "'Open Sans',  sans-serif, open-sans",
        color: "text.main",
        transform: "uppercase",
    },
    headerSecondary: {
        forwardAs: "p",
        size: "16px",
        fontFamily: "'Open Sans',  sans-serif, open-sans",
        lineHeight: "19px",
        weight: 500,
    },
    headerTertiary: {
        forwardAs: "p",
        size: "14px",
        lineHeight: "16px",
        weight: 700,
        fontFamily: "'Open Sans',  sans-serif, open-sans",
        color: "text.inverse",
        transform: "capitalize",
    },
    legend: {
        forwardAs: "span",
        size: "10px",
        color: "text.accent",
        transform: "uppercase",
        weight: 600,
    },
} as xBaseTheme["typography"];
